export default "__VITE_ASSET__6jYjd_wB__"